module.exports = __webpack_public_path__ + "static/img/Banner 1.41baf933.jpg";